import { create } from "zustand"
import { createGraphActions } from "./actions"
import { initialState } from "./initialState"
import type { GraphStore } from "./types"

export const useGraphStore = create<GraphStore>((set, get) => ({
  ...initialState,
  ...createGraphActions(set, get)
}))
